module.exports = __webpack_public_path__ + "static/media/openMsgActive.4a2fba15.svg";